// ESCUDOS.
//
// Mesma cadeia do 38 Brasil (`manager-shields38.js`): imagem local primeiro,
// escudo desenhado depois. Aqui a ordem e:
//
//   1. /escudos/<id>.png  -- se voce puser o arquivo, ele manda
//   2. escudo desenhado em SVG, com as CORES REAIS do clube e o monograma
//
// Por que nao baixar os logos: logo de clube e marca registrada, e um arquivo
// que eu baixasse entraria no repositorio sem licenca. O desenho com as cores
// certas da reconhecimento imediato -- azul e dourado e o Warriors, roxo e ouro
// e o Lakers -- sem usar a marca de ninguem. Quando voce tiver o direito de uso
// das imagens, e so soltar os arquivos na pasta: nao muda uma linha de codigo.

/** [primaria, secundaria, sigla] */
export const CREST_STYLE = {
  // NBA -- Leste
  'Atlanta Hawks': ['#e03a3e', '#26282a', 'ATL'],
  'Boston Celtics': ['#007a33', '#ba9653', 'BOS'],
  'Brooklyn Nets': ['#1d1d1b', '#ffffff', 'BKN'],
  'Charlotte Hornets': ['#1d1160', '#00788c', 'CHA'],
  'Chicago Bulls': ['#ce1141', '#111111', 'CHI'],
  'Cleveland Cavaliers': ['#6f263d', '#ffb81c', 'CLE'],
  'Detroit Pistons': ['#c8102e', '#1d42ba', 'DET'],
  'Indiana Pacers': ['#002d62', '#fdbb30', 'IND'],
  'Miami Heat': ['#98002e', '#f9a01b', 'MIA'],
  'Milwaukee Bucks': ['#00471b', '#eee1c6', 'MIL'],
  'New York Knicks': ['#006bb6', '#f58426', 'NYK'],
  'Orlando Magic': ['#0077c0', '#c4ced4', 'ORL'],
  'Philadelphia 76ers': ['#006bb6', '#ed174c', 'PHI'],
  'Toronto Raptors': ['#ce1141', '#111111', 'TOR'],
  'Washington Wizards': ['#002b5c', '#e31837', 'WAS'],
  // NBA -- Oeste
  'Dallas Mavericks': ['#00538c', '#002b5e', 'DAL'],
  'Denver Nuggets': ['#0e2240', '#fec524', 'DEN'],
  'Golden State Warriors': ['#1d428a', '#ffc72c', 'GSW'],
  'Houston Rockets': ['#ce1141', '#c4ced4', 'HOU'],
  'Los Angeles Clippers': ['#c8102e', '#1d428a', 'LAC'],
  'Los Angeles Lakers': ['#552583', '#fdb927', 'LAL'],
  'Memphis Grizzlies': ['#5d76a9', '#12173f', 'MEM'],
  'Minnesota Timberwolves': ['#0c2340', '#236192', 'MIN'],
  'New Orleans Pelicans': ['#0c2340', '#c8102e', 'NOP'],
  'Oklahoma City Thunder': ['#007ac1', '#ef3b24', 'OKC'],
  'Phoenix Suns': ['#1d1160', '#e56020', 'PHX'],
  'Portland Trail Blazers': ['#e03a3e', '#111111', 'POR'],
  'Sacramento Kings': ['#5a2d81', '#63727a', 'SAC'],
  'San Antonio Spurs': ['#c4ced4', '#111111', 'SAS'],
  'Utah Jazz': ['#002b5c', '#f9a01b', 'UTA'],

  // NBB
  Flamengo: ['#c52613', '#111111', 'FLA'],
  Franca: ['#111111', '#e8b800', 'FRA'],
  Minas: ['#0b3d91', '#ffffff', 'MIN'],
  'Sao Paulo': ['#c8102e', '#111111', 'SAO'],
  Paulistano: ['#c8102e', '#ffffff', 'PAU'],
  Bauru: ['#e03a3e', '#111111', 'BAU'],
  Pinheiros: ['#0b6b3a', '#ffffff', 'PIN'],
  Corinthians: ['#111111', '#ffffff', 'COR'],
  Mogi: ['#0b3d91', '#e03a3e', 'MOG'],
  Brasilia: ['#f2a900', '#111111', 'BSB'],
  'Caxias do Sul': ['#0b3d91', '#f2a900', 'CAX'],
  Unifacisa: ['#0b6b3a', '#f2a900', 'UNI'],
  'Fortaleza BC': ['#0b3d91', '#e03a3e', 'FOR'],
  Cerrado: ['#0b6b3a', '#f2a900', 'CER'],
  'Pato Basquete': ['#e03a3e', '#0b3d91', 'PAT'],
  'Rio Claro': ['#0b3d91', '#ffffff', 'RIO'],
};

const FALLBACK = ['#334155', '#cbd5e1', '??'];

export function crestStyle(teamName) {
  const found = CREST_STYLE[teamName];
  if (found) return { primary: found[0], secondary: found[1], abbr: found[2] };
  const abbr = String(teamName || '')
    .split(/\s+/).map((w) => w[0]).join('').slice(0, 3).toUpperCase() || FALLBACK[2];
  return { primary: FALLBACK[0], secondary: FALLBACK[1], abbr };
}

/** Caminho da imagem, se voce tiver os direitos e quiser usa-la. */
export function crestImagePath(teamId) {
  return `escudos/${teamId}.png`;
}
